module.exports = function getResource(label, vars = []) {
    const resources = {
        add: 'Ajouter',
        happyBday: 'Joyeux anniversaire',
        chooseGift: 'Choisissez votre cadeau d’anniversaire'
    };
    return resources[label];
};
